// import logo from './logo.svg';
import '../App.css';
import Home from '../pages/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes,Route,Link,Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import Create from '../pages/create';
import Update from '../pages/update';
import Logout from '../pages/logout';
import AuthUser from '../pages/AuthUser';

function Auth() {
    const {token,logout}=AuthUser();
    const logoutUser = ()=>{
        if( token !==undefined);
        logout();
        
    }
  
  return (
    <div>
    <nav className='navbar navbar-expand navbar-dark bg-dark'>
      <div className='navbar-nav mr-auto'>
      <li className='nav-item'>
        <Link to='/' className='nav-link'>Home</Link>
      </li>
      
      <li className='nav-item'>
        <Link to='/dashboard' className='nav-link'>Dashboard</Link>
      </li>
      
      <li className='nav-item'>
        <Link to='/create' className='nav-link'>Create</Link>
      </li>
      
      <li className='nav-item'>
        <span role="button" onClick={logoutUser} className='nav-link'>Logout</span>
      </li>
      
      </div>
    </nav>
    <div className='container'>
    <Routes>
    <Route path='/' element={<Home />} />
    <Route path='/create' element={<Create />} />
    <Route path='/dashboard' element={<Dashboard />} />
    <Route path='/update/:id' element={<Update />} />
    <Route path='/logout' element={<Logout />} />
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
    </div>
    </div>
  );
}

export default Auth;
